import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const BASE_URL = "https://www.assoacdt.com";

const PAGE_META = {
  "/": {
    title:
      "A.C.D.T. – Associazione Consulenti e Consumatori Digitali Tecnologici e di Sostenibilità",
    description:
      "A.C.D.T. è l'associazione ufficiale che promuove la formazione certificata di Consulenti e Consumatori Digitali, Tecnologici e di Sostenibilità. Tesseramento, Corso A.C.D.T. per la qualificazione professionale, registro nazionale Agg. MIMIT.",
  },
  "/corso": {
    title:
      "Corso Consulente Digitale Tecnologico e di Sostenibilità – A.C.D.T.",
    description:
      "Corso A.C.D.T. per la qualificazione professionale ufficiale ex Legge 4/2013. 20 moduli, 20 ore, attestato, CFP e CFU riconoscibili (Università Federico II tramite Pigreco). In promo: € 99 invece di € 179 per 2 mesi.",
  },
  "/privacy-policy": {
    title: "Privacy Policy – A.C.D.T.",
    description:
      "Informativa privacy di A.C.D.T. ai sensi del Regolamento UE 2016/679 (GDPR): titolare, finalità, base giuridica, diritti dell'interessato.",
  },
  "/cookie-policy": {
    title: "Cookie Policy – A.C.D.T.",
    description:
      "Cookie Policy di A.C.D.T.: tipologie di cookie utilizzati, gestione delle preferenze e riferimenti normativi.",
  },
  "/termini-e-condizioni": {
    title: "Termini e Condizioni – A.C.D.T.",
    description:
      "Termini e Condizioni dei servizi A.C.D.T.: tesseramento, corso, registro nazionale, modalità di pagamento e diritto di recesso 14 giorni.",
  },
  "/note-legali": {
    title: "Note Legali – A.C.D.T.",
    description:
      "Note legali e informazioni sull'editore A.C.D.T. – Associazione Consulenti e Consumatori Digitali.",
  },
};

function setOrCreateMeta(selector, attr, key, value) {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", value);
}

function setCanonical(href) {
  let link = document.head.querySelector("link[rel='canonical']");
  if (!link) {
    link = document.createElement("link");
    link.setAttribute("rel", "canonical");
    document.head.appendChild(link);
  }
  link.setAttribute("href", href);
}

export default function SEO({ title, description, image, pathname, jsonLd }) {
  const location = useLocation();
  const path = pathname || location.pathname || "/";

  useEffect(() => {
    const meta = PAGE_META[path] || PAGE_META["/"];
    const finalTitle = title || meta.title;
    const finalDescription = description || meta.description;
    const finalUrl = `${BASE_URL}${path === "/" ? "/" : path}`;
    const finalImage =
      image ||
      "https://customer-assets.emergentagent.com/job_b32a9d06-cd1a-4936-8a74-34f0d65c7ad3/artifacts/t9kdcc0c_ACDT_logo_800x520.jpg";

    // Title
    document.title = finalTitle;

    // Description
    setOrCreateMeta(
      "meta[name='description']",
      "name",
      "description",
      finalDescription
    );

    // Canonical
    setCanonical(finalUrl);

    // Open Graph
    setOrCreateMeta("meta[property='og:url']", "property", "og:url", finalUrl);
    setOrCreateMeta(
      "meta[property='og:title']",
      "property",
      "og:title",
      finalTitle
    );
    setOrCreateMeta(
      "meta[property='og:description']",
      "property",
      "og:description",
      finalDescription
    );
    setOrCreateMeta(
      "meta[property='og:image']",
      "property",
      "og:image",
      finalImage
    );

    // Twitter
    setOrCreateMeta(
      "meta[name='twitter:url']",
      "name",
      "twitter:url",
      finalUrl
    );
    setOrCreateMeta(
      "meta[name='twitter:title']",
      "name",
      "twitter:title",
      finalTitle
    );
    setOrCreateMeta(
      "meta[name='twitter:description']",
      "name",
      "twitter:description",
      finalDescription
    );
    setOrCreateMeta(
      "meta[name='twitter:image']",
      "name",
      "twitter:image",
      finalImage
    );

    // JSON-LD structured data (rimosso e ricreato per evitare accumulo)
    const existing = document.head.querySelector("script[data-seo-jsonld]");
    if (existing) existing.remove();
    if (jsonLd) {
      const script = document.createElement("script");
      script.type = "application/ld+json";
      script.setAttribute("data-seo-jsonld", "true");
      script.textContent = JSON.stringify(jsonLd);
      document.head.appendChild(script);
    }
  }, [path, title, description, image, jsonLd]);

  return null;
}
